<!-- Ported from the Polaris kit: src/components/ui/tabs/TabsTrigger.vue.
     Classes translated to Tailwind 3 by rebranding_frontend/port-kit-component.mjs.
     Change the design in the kit first, then re-port. -->
<script setup>
import { reactiveOmit } from '@vueuse/core';
import { TabsTrigger, useForwardProps } from 'reka-ui';
import { cn } from '../../lib/utils';

const props = defineProps({
  value: { type: [String, Number], required: true },
  disabled: { type: Boolean, required: false },
  asChild: { type: Boolean, required: false },
  as: { type: null, required: false },
  class: {
    type: [Boolean, null, String, Object, Array],
    required: false,
    skipCheck: true,
  },
});

// Polaris patch: the classes that start with group-data-[variant=line]/tabs-list are the line variant,
// switched on by data-variant on the list (see TabsList.vue).
const delegatedProps = reactiveOmit(props, 'class');

const forwardedProps = useForwardProps(delegatedProps);
</script>

<template>
  <TabsTrigger
    data-slot="tabs-trigger"
    :class="
      cn(
        `data-[state=active]:bg-polaris-background dark:data-[state=active]:text-polaris-foreground focus-visible:border-polaris-ring focus-visible:ring-polaris-ring/50 focus-visible:outline-polaris-ring dark:data-[state=active]:border-polaris-input dark:data-[state=active]:bg-polaris-input/30 text-polaris-foreground dark:text-polaris-muted-foreground inline-flex h-[calc(100%-1px)] min-w-6 flex-1 items-center justify-center gap-1.5 rounded-polaris-md border border-solid border-transparent px-2 py-1 type-polaris-label whitespace-nowrap transition-[color,box-shadow] focus-visible:ring-[3px] focus-visible:outline-1 disabled:pointer-events-none disabled:opacity-50 data-[state=active]:shadow [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4`,
        'group-data-[variant=line]/tabs-list:-mb-px group-data-[variant=line]/tabs-list:h-[calc(100%+1px)] group-data-[variant=line]/tabs-list:flex-none group-data-[variant=line]/tabs-list:rounded-none group-data-[variant=line]/tabs-list:border-0 group-data-[variant=line]/tabs-list:border-b-2 group-data-[variant=line]/tabs-list:border-transparent group-data-[variant=line]/tabs-list:px-0 group-data-[variant=line]/tabs-list:text-polaris-muted-foreground group-data-[variant=line]/tabs-list:data-[state=active]:border-polaris-foreground group-data-[variant=line]/tabs-list:data-[state=active]:bg-transparent group-data-[variant=line]/tabs-list:data-[state=active]:text-polaris-foreground group-data-[variant=line]/tabs-list:data-[state=active]:shadow-none',
        props.class
      )
    "
    v-bind="forwardedProps"
  >
    <slot />
  </TabsTrigger>
</template>
